export default __webpack_public_path__ + "static/media/plus.c5e64450.svg";